










import BaseSnackbar from 'vuecomponents/base_snackbar.vue'
import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const snackbars = namespace('snackbars')

@Component({
  components: { BaseSnackbar },
})
export default class extends Vue {
  @snackbars.Getter currentSnackbar
  @snackbars.Action executeCurrentSnackbarAction
}
